import React, { Component } from "react";
import styled from "styled-components";
import Testimonial from "../../assets/testimonialPics.png";
import QuotesPic from "../../assets/quotes.svg";
import Banner from "../../assets/banner3.jpg";
import { Column, Text } from "../theme/index";

const Wrapper = styled.div`
  background: ${props => props.background};
  background-size: cover;
  height: 600px;
  padding: 2em 0;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  align-content: flex-end;
  @media (max-width: 1100px) {
    flex-direction: column;
    height: 100%;
    width: 100%;
  }
`;

const Img = styled.img`
  width: 35%;
  margin-top: 0.5em;
`;

const Quotes = styled.img`
  margin-bottom: 2em;
`;

export default class Testimonials extends Component {
  state = {
    testimonial: {
      text:
        "AchieveCE gave me the opportunity to follow a passion I thought was out of reach. I was able to do the courses in the comfort of my house. I am so thankful to have found AchieveCE!",
      author: "JANE GALADRIEL",
      profession: "Nursing Graduate",
      state: "Florida"
    }
  };

  componentDidMount() {
    this.changeTestimonial();
  }

  changeTestimonial() {
    let arr = [
      {
        text:
          "AchieveCE gave me the opportunity to follow a passion I thought was out of reach. I was able to do the courses in the comfort of my house. I am so thankful to have found AchieveCE!",
        author: "JANE GALADRIEL",
        profession: "Nursing Graduate",
        state: "Florida"
      }
      // {
      //   text:
      //     "I highly recommend Hipstr...they even created this insanely awesome book for me with all my guests photos. I have probably looked at it 3000 times!!!",
      //   author: "Jessica S."
      // },
      // {
      //   text:
      //     "Our guests couldn't stop raving about them even after 2 months have passed since our wedding day",
      //   author: "Lily W."
      // },
      // {
      //   text:
      //     "The photos look INCREDIBLE and the props made it so fun. It was such a huge hit at the party that even my 92-year-old great-uncle got in on the action!",
      //   author: "Meagan M."
      // }
    ];
    let i = 0;
    setInterval(() => {
      if (i < arr.length) {
        this.setState({ testimonial: arr[i] }, () => {
          i++;
        });
      }
      if (i === arr.length) {
        i = 0;
      }
    }, 5000);
  }
  render() {
    return (
      <Wrapper background={`url('${Banner}')`}>
        <Column alignitems="center" width="75%" textalign="center">
          <Quotes src={QuotesPic} alt="AchieveCE Quotes" />
          <Text white testimony1>{`"${this.state.testimonial.text}"`}</Text>
          <div>
            <Text white testimony2>
              {this.state.testimonial.author}
            </Text>
            <Text white testimony2>
              {this.state.testimonial.profession}
            </Text>
            <Text white testimony2>
              {this.state.testimonial.state}
            </Text>
          </div>
          <Img src={Testimonial} />
        </Column>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Testimonials.jsx